import { Component, OnInit, Input,Output,EventEmitter } from '@angular/core';
import { BaseGaugeService } from './base-gauge.service';
import { ECharts } from "echarts";
import { initOpts } from '../../config/initOpts';
import { from, fromEvent } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { ChartResizeService } from '../../service/chart-resize.service';
import * as color from '../../config/colors';
import * as backgroundColor from '../../config/backgroundColor';

@Component({
  selector: 'bcac-base-gauge',
  templateUrl: './base-gauge.component.html',
  styleUrls: ['./base-gauge.component.scss']
})
export class BaseGaugeComponent implements OnInit {

  constructor(
    private baseGaugeService: BaseGaugeService,
    private chartResizeService: ChartResizeService,
  ) { }
  initOpts
  echartOption: any = this.baseGaugeService.getDefaultOption();
  ngOnInit() {
    this.initOpts = initOpts;
    this.initEchart();
    fromEvent(window, "resize")
      .pipe(debounceTime(200))
      .subscribe(() => {
        this.chartResizeService.autoResizeAdapt(this.optionInit, this.options);
      });
  }
  options;
  // echart配置项
  initEchart() {
    this.options = this.echartOption;
  }
  cardBgColor = "#fff";
  cardPadding = "1rem";
  chartTitle = {
    show: true,
    label: "图表名称",
  };
  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
  }
  //echarts数据
  @Input()
  set bcacChartData(value: any) {
    this.baseGaugeService.setDatas(this.echartOption,value);
  }
  // 标题
  @Input()
  set bcacTitle(value: string) {
    this.chartTitle.show = true;
    this.chartTitle.label = value;
  }
  // 关闭标题
  @Input()
  set bcacCloseTitle(value: boolean) {
    this.chartTitle.show = false;
  }
  // 下拉框数据
  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }
  @Input() bcacChartLoading:boolean;

  @Input()
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.cardPadding="0";
    }else{
      this.cardPadding="1rem";
    }
  }
  @Input()
  set bcacDarkMode(darkMode: boolean) {
    this.changeChartTitleColor(darkMode);
    this.changeCardBackgroundColor(darkMode);
  }
  chartTitleColor = '';
  changeChartTitleColor(darkMode: boolean | string) {
    if (!darkMode) {
      this.chartTitleColor = ''
    } else {
      this.chartTitleColor = color.darkModeTextColor;
    }
  }
  changeCardBackgroundColor(darkMode: boolean | string) {
    if (typeof (darkMode) === 'string') {
      this.cardBgColor = darkMode;
    } else if (darkMode) {
      this.cardBgColor = backgroundColor.darkModeBGColor;
    }
  }

  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }


  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true);
    }
  }
}
